/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { Link } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Home from "./pages/Home";
import Settings from "./pages/Settings";
import StudentDetails from "./pages/StudentDetails";
import Login from "./Login";
import Attendance from "./pages/Attendance";
import Notifications from "./pages/Notifications";
import ProtectedRoute from "./ProtectedRoute";
import Exam from "./pages/Exam";
import "./App.css";
import { Plugins } from "@capacitor/core";
import Students from "./pages/Students";
import StudentExamDetails from "./pages/StudentExamDetails";
import topimg from "../../parent_app/src/assets/bg-img/Untitled (Logo).png";
import Test from "./pages/Test";
import UpdatePassword from "./pages/UpdatePassword";

const showNotification = (message) => {
  if ("Notification" in window && Notification.permission === "granted") {
    new Notification(message);
  }
};

const setupOneSignal = () => {
  // Define OneSignal globally
  window.OneSignal = window.OneSignal || [];
  const OneSignal = window.OneSignal;

  OneSignal.push(function () {
    OneSignal.init({
      appId: "b0d2afe4-212e-49a5-afec-f671cc891be1",
      safari_web_id: "YOUR_SAFARI_WEB_ID",
      notifyButton: { enable: true },
      allowLocalhostAsSecureOrigin: true,
    });
  
    // Now it's safe to call it after init completes
    OneSignal.push(() => {
      if (typeof OneSignal.registerForPushNotifications === "function") {
        OneSignal.registerForPushNotifications();
      } else {
        console.warn("OneSignal.registerForPushNotifications is not available.");
      }
    });
    // Handle subscription change
    OneSignal.on("subscriptionChange", async (isSubscribed) => {
      console.log("User subscription status:", isSubscribed);
      if (isSubscribed) {
        const userId = await OneSignal.getUserId();
        if (userId) {
          console.log("Player ID:", userId);
          localStorage.setItem("player_id", userId);
        }
      }
    });

    // Check if push notifications are enabled
    OneSignal.isPushNotificationsEnabled(async (isEnabled) => {
      if (isEnabled) {
        const userId = await OneSignal.getUserId();
        console.log("Push Enabled - Player ID:", userId);
        localStorage.setItem("player_id", userId);
      } else {
        console.log("Prompting user for push permission");
        OneSignal.showSlidedownPrompt();
      }
    });

    // Fetch and store Player ID (redundant but safe)
    OneSignal.getUserId().then((userId) => {
      console.log("Final Player ID:", userId);
      localStorage.setItem("player_id", userId);
    });
  });
};




function App() {
  useEffect(() => {
    const interval = setInterval(() => {
      if (window.OneSignal && typeof window.OneSignal.push === "function") {
        clearInterval(interval);
        setupOneSignal();
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);
  

  useEffect(() => {
    if ("Notification" in window && Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  },[])

  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return !!localStorage.getItem("token");
  });

  const location = useLocation();
  const navigate = useNavigate(); // Impo

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
      if (location.pathname === "/login") {
        navigate("/students"); // Redirect to /students if user opens the app while logged in
      }
    }
  }, [location.pathname, navigate]);
  const hideMenuRoutes1 = ["/login"];
  const hideMenuRoutes2 = ["/login", "/students", "/test"];

  return (
    <div className="App">
      {/* Header */}
      {!hideMenuRoutes1.includes(location.pathname) && (
        <div className="header-area" id="headerArea">
          <div className="container">
            <div className="header header-style-five position-relative d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="logo-wrapper me-2">
                  <Link to="/home/:id">
                    <img
                      src={topimg}
                      alt="Logo"
                      style={{ width: "60px", height: "65px" }}
                    />
                  </Link>
                </div>
                <div
                  className="logo-text user-data-card"
                  style={{ padding: "20px 0 10px 0", marginLeft: "-5px" }}
                >
                  <h6
                    style={{ margin: 0, fontSize: "14px", fontWeight: "bold" }}
                  >
                    Sarvajna &
                  </h6>
                  <h6
                    style={{ margin: 0, fontSize: "14px", fontWeight: "bold" }}
                  >
                    Justice Shivaraj Patil
                  </h6>
                  <h6
                    style={{ margin: 0, fontSize: "12px", fontWeight: "300" }}
                  >
                    PU College of Science
                  </h6>
                </div>
              </div>
              <div className="form-label">
                <Link to="/settings" style={{ fontSize: "12px" }}>
                  <i className="bi bi-list" style={{ fontSize: "24px" }}></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Footer Navigation */}
      {!hideMenuRoutes2.includes(location.pathname) && (
        <div className="footer-nav-area" id="footerNav">
          <div className="container px-0">
            <div className="footer-nav position-relative">
              <ul className="h-100 d-flex align-items-center justify-content-between ps-0">
                <li>
                  <Link to="/home" style={{ fontSize: "12px" }}>
                    <i className="bi bi-house" style={{ fontSize: "24px" }}></i>
                    <span>Home</span>
                  </Link>
                </li>
                <li>
                  <Link to="/student-details/">
                    <i
                      className="bi bi-person-circle"
                      style={{ fontSize: "24px" }}
                    ></i>
                    <span>My Child</span>
                  </Link>
                </li>
                <li>
                  <Link to="/attendance">
                    <i
                      className="bi bi-pencil-square"
                      style={{ fontSize: "24px" }}
                    ></i>
                    <span>Attendance</span>
                  </Link>
                </li>
                <li>
                  <Link to="/notifications">
                    <i
                      className="bi bi-bell-fill"
                      style={{ fontSize: "24px" }}
                    ></i>
                    <span>Updates</span>
                  </Link>
                </li>
                <li>
                  <Link to="/settings">
                    <i className="bi bi-gear" style={{ fontSize: "24px" }}></i>
                    <span>Settings</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* Routes */}
      <Routes>
        <Route
          path="/login"
          element={isLoggedIn ? <Navigate to="/students" replace /> : <Login />}
        />
        <Route
          path="*"
          element={
            <Navigate to={isLoggedIn ? "/students" : "/login"} replace />
          }
        />
        <Route element={<ProtectedRoute />}>
          <Route path="/home" element={<Home />} />
          <Route path="/test" element={<Test />} />
          <Route path="/update-password" element={<UpdatePassword />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/student-details" element={<StudentDetails />} />
          <Route path="/attendance" element={<Attendance />} />
          <Route path="/students" element={<Students />} />
          <Route path="/student-result" element={<StudentExamDetails />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/exam" element={<Exam />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;